/* eslint-disable react/no-unstable-nested-components */
import { useQuery } from "@apollo/client";
import FinancialsSheetForComparisonQuery from "components/financials/modern/graphql/FinancialsSheetForComparisonQuery";
import type {
  IFinancialsSheetForComparisonQuery,
  IFinancialsSheetForComparisonQueryVariables,
} from "components/financials/modern/graphql/__generated__/FinancialsSheetForComparisonQuery.generated";
import type {
  IFinancialsSheetComparisonAdversaryInput,
  IIndicatorDataSource,
  IFinancialsSheetLimitCriterion,
  IFinancialsStatementType,
  IPlatformVertical,
} from "types/graphqlTypes";

type UseFinancialsSheetForComparisonParams = {
  indicators: string[];
  indicatorDataSource: IIndicatorDataSource;
  statementType: IFinancialsStatementType;
  currency: string;
  vertical: IPlatformVertical;
  adversaries: IFinancialsSheetComparisonAdversaryInput[];
  limit: number;
  limitCriterion: IFinancialsSheetLimitCriterion;
  filterByInterim: string | null;
  skip?: boolean;
};

export default function useFinancialsSheetForComparison({
  indicators,
  indicatorDataSource,
  statementType,
  currency,
  vertical,
  adversaries,
  limit,
  limitCriterion,
  filterByInterim,
  skip = false,
}: UseFinancialsSheetForComparisonParams) {
  const { data, previousData, loading, refetch, networkStatus } = useQuery<
    IFinancialsSheetForComparisonQuery,
    IFinancialsSheetForComparisonQueryVariables
  >(FinancialsSheetForComparisonQuery, {
    skip,
    notifyOnNetworkStatusChange: true,
    variables: {
      indicators,
      indicatorDataSource,
      statementType,
      currency,
      vertical,
      adversaries,
      limit,
      limitCriterion,
      filterByInterim,
      filterByReportDateAfter: null,
      filterByReportDateBefore: null,
    },
  });

  const financialsSheet =
    (loading && !data ? previousData?.financialsSheetForComparison : data?.financialsSheetForComparison) || null;

  return {
    networkStatus,
    loading,
    refetch,

    reportDates: financialsSheet?.reportDates || [],
    indicators: financialsSheet?.indicators || [],
    adversaries: financialsSheet?.adversaries || [],

    systemTemplate: financialsSheet?.systemTemplate || null,
    renderingTemplate:
      financialsSheet?.viewerSelectedTemplate ||
      financialsSheet?.overridingTemplate ||
      financialsSheet?.systemTemplate ||
      null,
  };
}
